import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-610968ff"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "bar",
  style: {"width":"100%"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, /*#__PURE__*/_toDisplayString("IPV4"), -1))
const _hoisted_3 = {
  key: 1,
  class: "expandRow"
}
const _hoisted_4 = {
  colspan: "12",
  style: {"padding":"0"}
}
const _hoisted_5 = { id: "expand_mem" }
const _hoisted_6 = { id: "expand_swap" }
const _hoisted_7 = { id: "expand_hdd" }
const _hoisted_8 = {
  class: "bar",
  style: {"width":"100%"}
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "维护中", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, /*#__PURE__*/_toDisplayString('–'), -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, /*#__PURE__*/_toDisplayString('-'), -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, /*#__PURE__*/_toDisplayString('–'), -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, /*#__PURE__*/_toDisplayString('–'), -1))
const _hoisted_14 = {
  class: "bar",
  style: {'width': `${100}%`}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.server.getStatus)
      ? (_openBlock(), _createElementBlock("tr", {
          key: 0,
          class: "tableRow",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.collapsed = !_ctx.collapsed))
        }, [
          _createElementVNode("td", null, [
            _createElementVNode("div", {
              class: _normalizeClass(["ui progress", {'success': _ctx.server.getStatus, 'error': !_ctx.server.getStatus}])
            }, [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("span", null, _toDisplayString(_ctx.server.getStatus ? '运行中' : '离线了'), 1)
              ])
            ], 2)
          ]),
          _hoisted_2,
          _createElementVNode("td", null, _toDisplayString(_ctx.server.name), 1),
          _createElementVNode("td", null, _toDisplayString(_ctx.server.data.type), 1),
          _createElementVNode("td", null, _toDisplayString(_ctx.server.location), 1),
          _createElementVNode("td", null, _toDisplayString(_ctx.server.data.day || '–'), 1),
          _createElementVNode("td", null, _toDisplayString(_ctx.server.getStatus ? ((Number(_ctx.server.data.fz)+Number(_ctx.server.data.CPU)+Number(_ctx.server.data.MEM))>100)?100+'%':(Number(_ctx.server.data.fz/3)+Number(_ctx.server.data.CPU/3)+Number(_ctx.server.data.MEM/3)).toFixed(0)+'%' : '-'), 1),
          _createElementVNode("td", null, _toDisplayString(_ctx.server.getStatus ? `${_ctx.tableRowByteConvert(_ctx.server.data.RX?_ctx.server.data.RX:0)} | ${_ctx.tableRowByteConvert(_ctx.server.data.TX?_ctx.server.data.TX:0)}` : '–'), 1),
          _createElementVNode("td", null, _toDisplayString(_ctx.server.getStatus ? `${_ctx.tableRowByteConvert(_ctx.server.data.RXT?_ctx.server.data.RXT:0)} | ${_ctx.tableRowByteConvert(_ctx.server.data.TXT?_ctx.server.data.TXT:0)}` : '–'), 1),
          _createElementVNode("td", null, _toDisplayString(_ctx.server.getStatus ? `${_ctx.tableRowByteConvert(_ctx.server.RX?_ctx.server.RX:0)} | ${_ctx.tableRowByteConvert(_ctx.server.TX?_ctx.server.TX:0)}` : '–'), 1),
          _createElementVNode("td", null, [
            _createElementVNode("div", {
              class: _normalizeClass(["ui progress", _ctx.getProcessBarStatus(_ctx.server.data.CPU)])
            }, [
              _createElementVNode("div", {
                class: "bar",
                style: _normalizeStyle({'width': `${(_ctx.server.data.CPU).toString()}%`})
              }, _toDisplayString(_ctx.server.getStatus ? `${(_ctx.server.data.CPU).toString()}%` : '离线了'), 5)
            ], 2)
          ]),
          _createElementVNode("td", null, [
            _createElementVNode("div", {
              class: _normalizeClass(["ui progress", _ctx.getProcessBarStatus(_ctx.server.data.MEM)])
            }, [
              _createElementVNode("div", {
                class: "bar",
                style: _normalizeStyle({'width': `${(_ctx.server.data.MEM).toString()}%`})
              }, _toDisplayString(_ctx.server.getStatus ? `${(_ctx.server.data.MEM).toString()}%` : '离线了'), 5)
            ], 2)
          ]),
          _createElementVNode("td", null, [
            _createElementVNode("div", {
              class: _normalizeClass(["ui progress", _ctx.getProcessBarStatus(_ctx.server.data.FS)])
            }, [
              _createElementVNode("div", {
                class: "bar",
                style: _normalizeStyle({'width': `${(_ctx.server.data.FS).toString()}%`})
              }, _toDisplayString(_ctx.server.getStatus ? `${(_ctx.server.data.FS).toString()}%` : '离线了'), 5)
            ], 2)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.server.getStatus)
      ? (_openBlock(), _createElementBlock("tr", _hoisted_3, [
          _createElementVNode("td", _hoisted_4, [
            _createElementVNode("div", {
              class: _normalizeClass({collapsed: _ctx.collapsed}),
              style: _normalizeStyle({'max-height': _ctx.server.getStatus ? '' : '0'})
            }, [
              _createElementVNode("div", _hoisted_5, "内存信息: " + _toDisplayString(_ctx.server.getStatus ? `${_ctx.server.data.MEMactive} / ${_ctx.server.data.MEMtotal}` : '–'), 1),
              _createElementVNode("div", _hoisted_6, "TCP连接: " + _toDisplayString(_ctx.server.getStatus ? `${_ctx.server.data.listen} / ${_ctx.server.data.established} / ${_ctx.server.data.all}` : '–'), 1),
              _createElementVNode("div", _hoisted_7, "硬盘信息: " + _toDisplayString(_ctx.server.getStatus ? `${_ctx.server.data.fsw}/ ${_ctx.server.data.FStotal}` : '–'), 1)
            ], 6)
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.server.getStatus)
      ? (_openBlock(), _createElementBlock("tr", {
          key: 2,
          class: "tableRow",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.collapsed = !_ctx.collapsed))
        }, [
          _createElementVNode("td", null, [
            _createElementVNode("div", {
              class: _normalizeClass(["ui progress", {'success': _ctx.server.getStatus, 'error': !_ctx.server.getStatus}])
            }, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", null, _toDisplayString(_ctx.server.getStatus ? '运行中' : '离线了'), 1)
              ])
            ], 2)
          ]),
          _createElementVNode("td", null, _toDisplayString(_ctx.server.name), 1),
          _hoisted_9,
          _createElementVNode("td", null, _toDisplayString(_ctx.server.location), 1),
          _hoisted_10,
          _hoisted_11,
          _hoisted_12,
          _hoisted_13,
          _createElementVNode("td", null, [
            _createElementVNode("div", {
              class: _normalizeClass(["ui progress", _ctx.getProcessBarStatus(100)])
            }, [
              _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.server.getStatus ? `${(100).toString()}%` : '维护中'), 1)
            ], 2)
          ]),
          _createElementVNode("td", null, [
            _createElementVNode("div", {
              class: _normalizeClass(["ui progress", _ctx.getProcessBarStatus(100)])
            }, [
              _createElementVNode("div", {
                class: "bar",
                style: _normalizeStyle({'width': `${(100).toString()}%`})
              }, _toDisplayString(_ctx.server.getStatus ? `${(100).toString()}%` : '维护中'), 5)
            ], 2)
          ]),
          _createElementVNode("td", null, [
            _createElementVNode("div", {
              class: _normalizeClass(["ui progress", _ctx.getProcessBarStatus(100)])
            }, [
              _createElementVNode("div", {
                class: "bar",
                style: _normalizeStyle({'width': `${(100).toString()}%`})
              }, _toDisplayString(_ctx.server.getStatus ? `${(100).toString()}%` : '维护中'), 5)
            ], 2)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}